/** Market used when no country-specific variant matches the visitor. */
export const GLOBAL_MARKET = "global";

export const MARKET_PATTERN = /^(global|[A-Z]{2})$/;

/**
 * Normalizes a Cloudflare `request.cf.country` value. Cloudflare reports `XX` for unknown
 * locations and `T1` for Tor exit nodes; both are treated as "no country".
 */
export function normalizeCountry(country: string | null | undefined): string | null {
  if (!country) return null;
  const code = country.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code) || code === "XX" || code === "T1") return null;
  return code;
}

export interface MarketScoped {
  market: string;
  isEnabled: boolean;
}

/**
 * Picks the delivery variant for a visitor: an enabled variant for the visitor's country wins,
 * otherwise the enabled global variant. Returns null when the game is not deliverable there.
 */
export function resolveVariant<T extends MarketScoped>(
  variants: readonly T[],
  country: string | null | undefined,
): T | null {
  const code = normalizeCountry(country);
  if (code) {
    const local = variants.find((v) => v.isEnabled && v.market === code);
    if (local) return local;
  }
  return variants.find((v) => v.isEnabled && v.market === GLOBAL_MARKET) ?? null;
}
